<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <div v-if="type != '11'" class="control">
        <label class="label">输入{{name}}帐号</label>
        <div>
          <input type="text" class="input width-3" placeholder="搜索帐号" v-model="accountName">
          <button class="button is-primary" @click="search">搜索</button>
        </div>
      </div>
      <div class="control">
        <label class="label">若搜索无效,直接使用{{name}} Key订阅</label>
        <div>
          <input v-if="type != '11'" type="text" class="input width-2" :placeholder="getPlaceholderName" v-model="subscribeAccountName">
          <input type="text" class="input width-2" :placeholder="getPlaceholderId" v-model="subscribeAccountKey">
          <button class="button is-primary" @click="searchSubscribe">订阅</button>
        </div>
      </div>
      <div class="control">
        <el-tooltip class="item" effect="dark" :content="tips" placement="top-start">
           <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
        </el-tooltip>
      </div>
    </article>
  </div>
</template>
<script type="text/babel">

  export default{
    data(){
      return{
        tips:"",
        name:"",
        type:0,
        accountName:"",
        subscribeAccountName:"",
        subscribeAccountKey:""
      }
    },
    mounted(){
      this.type = this.$route.query.type;
      this.name = this.$route.query.name;
      if(this.type == 12){//微信
        this.tips = this.name+" Key 是指"+this.name+"的微信名称和微信号";
      }else{
        this.tips = this.name+" Key 是指"+this.name+"的用户名称和用户ID";
      }
    },
    computed:{
      getPlaceholderId(){
        return "输入"+this.name+"用户ID"
      },
      getPlaceholderName(){
        return "输入"+this.name+"用户名"
      },
    },
    methods:{
      showModal(){
        this.dialogVisible = true
      },
      /**
       * 搜索
       * */
      search(){
        this.$emit("search-click",this.accountName);
      },
      /**
       * 订阅
       * */
      searchSubscribe(){
        this.$emit("search-subscribe-click", this.subscribeAccountName,this.subscribeAccountKey)
      }
    }
  }
</script>
<style lang="less">
  .margin-left3{
    margin-left: 30px;
  }
  .exclamation-icon{

  }
</style>
